import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').config(housingAssociationRouterConfig);

    /** @ngInject */
    function housingAssociationRouterConfig($stateProvider) {
        $stateProvider.state('housing_association', {
            url: '/panel-klienta',
            template:
                require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/_housing_association/housing_association.html'),
            controller: 'HousingAssociationController',
            controllerAs: 'HousingAssociationCtrl',
        });
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/_housing_association/housing_association.route.ts